var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-post",class:{
    'is-note': _vm.isNote,
    'is-private': _vm.isPrivate,
    'is-agent-post': _vm.authorIsAgent
  }},[(_vm.isSiteChange || _vm.isLog || _vm.isSytem)?_c('task-post-icon',{staticClass:"task-post-avatar is-hidden-mobile",attrs:{"size":35,"icon":_vm.isSiteChange ? 'random' : 'info'}}):_c('avatar',{staticClass:"task-post-avatar is-hidden-mobile",attrs:{"name":_vm.authorName,"avatar":_vm.authorAvatar,"size":35}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }